export default "__VITE_ASSET__d98af0ff__"